import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Divider from '@material-ui/core/Divider';
import Footer from '../../Components/Layout/Footer';
import Routes from '../../Routing/Routes';
import Seo from '../../Routing/Seo';

import LayoutStyles from '../../Components/Layout/Styles/LayoutStyles';

type Props = {
  classes: Object,
};

const styles = () => ({
  layout: {
    ...LayoutStyles.centered800Layout,
    marginTop: '100px',
  },
});

function Cgu({ classes }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        {Seo.title(
          `Conditions générales d'utilisations${t(`${Routes.currentNamespace()}.SEO.SUFFIX`)}`,
        )}
        {Seo.description("Nos conditions générales d'utilisations")}
        {Seo.canonical(null, Routes.cguUrl())}
      </Helmet>
      <Grid container className={classes.container}>
        <div className={classes.layout}>
          <Typography
            variant="h1"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.TITLE'),
            }}
          />

          <Typography
            variant="subtitle1"
            component="h2"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.SUBTITLE'),
            }}
          />

          <Divider light style={{ margin: '20px', background: 'none' }} />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_1'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_1'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_2'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_2'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_3'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_3'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_4'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_4'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_5'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_5'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_6'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_6'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_7'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_7'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_8'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_8'),
            }}
          />

          <Typography
            variant="h4"
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CHAP_9'),
            }}
          />

          <Typography
            gutterBottom
            dangerouslySetInnerHTML={{
              __html: t('WELLO.CGU.CONTENT_9'),
            }}
          />

          <Grid item md={12} style={{ padding: '60px' }} align="middle">
            {/* <BackButton /> */}
            <Button component={Link} to="/">
              <Typography
                variant="subtitle2"
                color="textPrimary"
                component="p"
                dangerouslySetInnerHTML={{
                  __html: t('BACK'),
                }}
              />
            </Button>
          </Grid>
        </div>
      </Grid>
      <Footer />
    </>
  );
}

export default withRouter(withStyles(styles)(Cgu));
